import { FormatTypeCopySink } from './format-type.copysink';
import { Metamodel } from 'app/model/base/model';
import { DeltaDataset, Owned, UpdateMethod, UpdateMethodType } from 'shell-models-lib';
import { DeltaFormatWriteSettings } from './format-write-settings/delta-format-write-settings';

@Metamodel.model({
    name: 'DeltaSink',
    display: [],
    referable: true,
    tags: { datasetModel: Metamodel.modelFor(DeltaDataset) }
})
export class DeltaSink extends FormatTypeCopySink {
    @Metamodel.attribute({
        display: stringResources.ModelName_FormatReadSettings,
        type: DeltaFormatWriteSettings.MODEL
    })
    public formatSettings: DeltaFormatWriteSettings;

    public get updateMethod(): UpdateMethodType {
        switch (this.formatSettings?.writeBehavior) {
            case 'Upsert':
                return UpdateMethod.Upsert;
            case 'Overwrite':
                return UpdateMethod.Overwrite;
            case 'Insert':
                return UpdateMethod.Append;
            default:
                return undefined;
        }
    }

    public set updateMethod(value: UpdateMethodType) {
        if (this.formatSettings == null) {
            this.formatSettings = Owned.create<DeltaFormatWriteSettings>(DeltaFormatWriteSettings.MODEL, this);
        }
        // Format settings default to Insert; assigning an unset method must not materialize Append.
        if (value == null) {
            this.formatSettings.writeBehavior = undefined;
            return;
        }
        switch (value) {
            case UpdateMethod.Append:
                this.formatSettings.writeBehavior = 'Insert';
                break;
            case UpdateMethod.Upsert:
                this.formatSettings.writeBehavior = 'Upsert';
                break;
            case UpdateMethod.Overwrite:
                this.formatSettings.writeBehavior = 'Overwrite';
                break;
            default:
        }
    }

    public get upsertKeyColumns(): string[] {
        return this.formatSettings?.upsertKeys;
    }

    public set upsertKeyColumns(value: string[]) {
        if (this.formatSettings == null) {
            this.formatSettings = Owned.create<DeltaFormatWriteSettings>(DeltaFormatWriteSettings.MODEL, this);
        }
        this.formatSettings.upsertKeys = value;
    }
}
